import { render } from "./MessageDropdown.vue?vue&type=template&id=d1c32726"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"

import "./MessageDropdown.vue?vue&type=style&index=0&id=d1c32726&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__